import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function SEO({ 
  title, 
  description, 
  keywords,
  lang = "fr",
  image = "/jura-paysage.jpg"
}) {
  const location = useLocation();
  const siteUrl = "https://jurashuttle.ch";
  const currentUrl = `${siteUrl}${location.pathname}`;

  const defaultTitle = "Van-2-Go.ch - Location Minibus 9 Places | Jura, Suisse";
  const defaultDescription = "Location de minibus 9 places dans le Jura. Tarifs à partir de 170 CHF/jour. Assurance tous risques, 200 km inclus. Réservation en ligne instantanée.";
  const defaultKeywords = "location minibus, minibus Jura, location véhicule, transport groupe, minibus 9 places";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Open Graph */}
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={`${siteUrl}${image}`} />
      
      {/* Twitter */}
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title || defaultTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={`${siteUrl}${image}`} />
      
      {/* Canonical */}
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
}